import { useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { FETCH_MASTER_DATA_TIME_OUT, REQUEST_STATE, UseFetchRefs } from "../../dataTypes";
import mapUseFetchRefs from "../../utils/mapUseFetchRefs";
import mergeFetchedTimestampRefAndStateEntities from "../../utils/mergeFetchedTimestampRefAndStateEntities";
import { selectServiceTypeEntities } from "../serviceTypeSelectors";
import { fetchServiceType } from "../reducers/fetchServiceType";
import { useValidateUserIsLoggedIn } from "../../utils/useValidateUserIsLoggedIn";
import { setError } from "../../dialog/dialogSlice";

let refs: UseFetchRefs;

const useFetchServiceType = () => {
  const dispatch = useAppDispatch();
  const result = useValidateUserIsLoggedIn();

  const serviceTypes = useAppSelector(selectServiceTypeEntities);

  if ((refs as UseFetchRefs | undefined) === undefined) {
    refs = mapUseFetchRefs(serviceTypes);
  }

  useEffect(() => {
    refs = mergeFetchedTimestampRefAndStateEntities(refs, mapUseFetchRefs(serviceTypes));
  }, [serviceTypes]);

  const loadServiceType = useCallback(
    async (id?: string) => {
      if (result.isError) {
        dispatch(setError({ value: result.errorMessage }));
      } else {
        if (id) {
          const ref = refs[id];

          if (
            !ref ||
            (ref.requestState !== REQUEST_STATE.PENDING &&
              (ref.fetchedTimestamp + FETCH_MASTER_DATA_TIME_OUT < Date.now() || !ref.hasFetchedDetail))
          ) {
            refs[id] = { fetchedTimestamp: Date.now(), hasFetchedDetail: true, requestState: REQUEST_STATE.PENDING };
            await dispatch(fetchServiceType(id));
          }
        }
      }
    },
    [dispatch, result],
  );

  return loadServiceType;
};

export default useFetchServiceType;
